import React, { lazy } from "react";
import UIDs from "../../UIDs";

const ItemsScreen = lazy(() => import("../../screens/admin/equipment/ItemsScreen"));
const HomeScreen = lazy(() => import("../../screens/admin/equipment/HomeScreen"));
const ReportsScreen = lazy(() => import("../../screens/admin/equipment/ReportsScreen"));
const CategoriesScreen = lazy(() => import("../../screens/admin/equipment/CategoriesScreen"));
const CheckoutsScreen = lazy(() => import("../../screens/admin/equipment/CheckoutsScreen"));
const ReservationsScreen = lazy(() => import("../../screens/admin/equipment/ReservationsScreen"));
const ManagersScreen = lazy(() => import("../../screens/admin/equipment/ManagersScreen"));
const EditManagerScreen = lazy(() => import("../../screens/admin/equipment/EditManagerScreen"));
const EquipmentPolicyScreen = lazy(() => import("../../screens/admin/equipment/EquipmentPolicyScreen"));
const EditCheckoutScreen = lazy(() => import("../../screens/admin/equipment/EditCheckoutScreen"));
const EditReservationScreen = lazy(() => import("../../screens/admin/equipment/EditReservationScreen"));
const EditCheckoutV2Screen = lazy(() => import("../../screens/admin/equipment/EditCheckoutV2Screen"));
const EditReservationV2Screen = lazy(() => import("../../screens/admin/equipment/EditReservationV2Screen"));
const ViewCheckoutDetailV2Screen = lazy(() => import("../../screens/admin/equipment/ViewCheckoutDetailV2Screen"));
const ViewReservationDetailV2Screen = lazy(() => import("../../screens/admin/equipment/ViewReservationDetailV2Screen"));
const ViewItemScreen = lazy(() => import("../../screens/admin/equipment/ViewItemScreen"));
const ViewItemV2Screen = lazy(() => import("../../screens/admin/equipment/ViewItemV2Screen"));
const EditItemScreen = lazy(() => import("../../screens/admin/equipment/EditItemScreen"));
const EditItemV2Screen = lazy(() => import("../../screens/admin/equipment/EditItemV2Screen"));
const ItemsV2Screen = lazy(() => import("../../screens/admin/equipment/ItemsV2Screen"));
const MakePaymentScreen = lazy(() => import("../../screens/admin/MakePaymentScreen"));
const MembershipsListScreen = lazy(() => import("../../screens/admin/membership/MembershipsListScreen"));
const EditMembershipScreen = lazy(() => import("../../screens/admin/membership/EditMembershipScreen"));
const MembershipUsageHistoryScreen = lazy(() => import("../../screens/admin/membership/MembershipUsageHistoryScreen"));
const ViewMembershipScreen = lazy(() => import("../../screens/admin/membership/ViewMembershipScreen"));
const FacilityAccessScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessScreen"));
const FacilityRainOutListScreen = lazy(() => import("../../screens/admin/facility/FacilityRainOutListScreen"));
const ViewFacilityScreen = lazy(() => import("../../screens/admin/facility/ViewFacilityScreen"));
const FacilityLiveViewScreen = lazy(() => import("../../screens/admin/facility/FacilityLiveViewScreen"));
const EditFacilityAccessScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAccessScreen"));
const EditFacilityScreen = lazy(() => import("../../screens/admin/facility/EditFacilityScreen"));
const EditFacilityAreaScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAreaScreen"));
const FacilityAccessHistoryScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessHistoryScreen"));
const FacilityCheckInScreen = lazy(() => import("../../screens/admin/facility/FacilityCheckInScreen"));
const MemberManagementScreen = lazy(() => import("../../screens/admin/network/MemberManagementScreen"));
const ActivateMembersScreen = lazy(() => import("../../screens/admin/network/ActivateMembersScreen"));
const MemberActivityHistoryScreen = lazy(() => import("../../screens/admin/network/MemberActivityHistoryScreen"));
const SignedWaiversScreen = lazy(() => import("../../screens/admin/network/SignedWaiversScreen"));
const ExportStatisticalReportScreen = lazy(() => import("../../screens/admin/network/ExportStatisticalReportScreen"));
const IntramuralsStatisticsScreen = lazy(() => import("../../screens/admin/network/IntramuralsStatisticsScreen"));
const ClubStatisticsScreen = lazy(() => import("../../screens/admin/network/ClubStatisticsScreen"));
const FitnessStatisticsScreen = lazy(() => import("../../screens/admin/network/FitnessStatisticsScreen"));
const ReservationStatisticsScreen = lazy(() => import("../../screens/admin/network/ReservationStatisticsScreen"));
const MarchMadnessScreen = lazy(() => import("../../screens/admin/network/MarchMadnessScreen"));
const SuspensionDetailScreen = lazy(() => import("../../screens/admin/network/SuspensionDetailScreen"));
const EditSuspensionScreen = lazy(() => import("../../screens/admin/network/EditSuspensionScreen"));
const SuspensionScreen = lazy(() => import("../../screens/admin/network/SuspensionScreen"));
const IneligibilityScreen = lazy(() => import("../../screens/admin/network/IneligibilityScreen"));
const TeamManagementScreen = lazy(() => import("../../screens/admin/network/TeamManagementScreen"));
const SidManagementScreen = lazy(() => import("../../screens/admin/network/SidManagementScreen"));
const SidImportScreen = lazy(() => import("../../screens/admin/network/SidImportScreen"));
const CreateAccountsScreen = lazy(() => import("../../screens/admin/network/CreateAccountsScreen"));
const AccountImportScreen = lazy(() => import("../../screens/admin/network/AccountImportScreen"));
const OfficialScreen = lazy(() => import("../../screens/admin/network/OfficialScreen"));
const OfficialSearchScreen = lazy(() => import("../../screens/admin/network/OfficialSearchScreen"));
const RefereeScreen = lazy(() => import("../../screens/admin/network/RefereeScreen"));
const FormManageScreen = lazy(() => import("../../screens/admin/club/FormManageScreen"));
const TravelRequestManageScreen = lazy(() => import("../../screens/admin/club/TravelRequestManageScreen"));
const TravelRequestsScreen = lazy(() => import("../../screens/admin/club/TravelRequestsScreen"));
const ViewFormResponsesScreen = lazy(() => import("../../screens/admin/club/ViewFormResponsesScreen"));
const MoveMembersScreen = lazy(() => import("../../screens/admin/network/MoveMembersScreen"));
const SwipeCardCheckInScreen = lazy(() => import("../../screens/admin/network/SwipeCardCheckInScreen"));
const MoveTeamsScreen = lazy(() => import("../../screens/admin/network/MoveTeamsScreen"));
const MoveGamesScreen = lazy(() => import("../../screens/admin/network/MoveGamesScreen"));
const DashboardScreen = lazy(() => import("../../screens/admin/DashboardScreen.jsx"));
const ProductListScreen = lazy(() => import('../../screens/admin/products/list.jsx'));
const ProductDetailsScreen = lazy(() => import('../../screens/admin/products/details.jsx'));
const ProductCreateScreen = lazy(() => import('../../screens/admin/products/create.jsx'));
const OrderCreateScreen = lazy(() => import('../../screens/admin/order/create.jsx'));
const OrderListScreen = lazy(() => import('../../screens/admin/order/list.jsx'));
const OrderDetailsScreen = lazy(() => import('../../screens/admin/order/details.jsx'));
const EcommerceScreen = lazy(() => import('../../screens/admin/e-commerce.jsx'));
const InvoiceCreateScreen = lazy(() => import('../../screens/admin/invoices/create.jsx'));
const InvoiceListScreen = lazy(() => import('../../screens/admin/invoices/list.jsx'));
const InvoiceDetailsScreen = lazy(() => import('../../screens/admin/invoices/details.jsx'));
const InvoiceScreen = lazy(() => import('../../screens/admin/invoices/invoice.jsx'));
const CheckoutScreen = lazy(() => import('../../screens/admin/checkout.jsx'));

// Shop screens
const ShopProductListScreen = lazy(() => import('../../screens/admin/shop/products/ProductListScreen.jsx'));
const ShopProductEditScreen = lazy(() => import('../../screens/admin/shop/products/ProductEditScreen.jsx'));
const ShopProductDetailScreen = lazy(() => import('../../screens/admin/shop/products/ProductDetailScreen.jsx'));
const ShopCartScreen = lazy(() => import('../../screens/admin/shop/cart/CartScreen.jsx'));

// Shop orders screens
const ShopOrderListScreen = lazy(() => import('../../screens/admin/shop/orders/OrderListScreen.jsx'));
const ShopOrderDetailScreen = lazy(() => import('../../screens/admin/shop/orders/OrderDetailScreen.jsx'));
const ShopCheckoutScreen = lazy(() => import('../../screens/admin/shop/checkout/CheckoutScreen.jsx'));
const FacilityCalendarScreen = lazy(() => import("../../screens/portal/FacilityCalendarScreen.jsx"));
const OfferingsScreen = lazy(() => import("../../screens/portal/OfferingsScreen.jsx"));
const OfferingsSettingsScreen = lazy(() => import("../../screens/admin/OfferingsSettingsScreen.jsx"));
const CalendarListScreen = lazy(() => import("../../screens/admin/eventcalendar/CalendarListScreen.jsx"));
const EditCalendarScreen = lazy(() => import("../../screens/admin/eventcalendar/EditCalendarScreen.jsx"));
const RoomListScreen = lazy(() => import("../../screens/admin/locker/RoomListScreen.jsx"));
const FloorplanDesignScreen = lazy(() => import("../../screens/admin/locker/FloorplanDesignScreen.jsx"));
const EditRoomScreen = lazy(() => import("../../screens/admin/locker/EditRoomScreen.jsx"));
const LockerManagementScreen = lazy(() => import("../../screens/admin/locker/LockerManagementScreen.jsx"));

// Payment screens
const ReceivedPaymentsScreen = lazy(() => import("../../screens/admin/payment/ReceivedPaymentsScreen.jsx"));
const RequiredPaymentsScreen = lazy(() => import("../../screens/admin/payment/RequiredPaymentsScreen.jsx"));
const PaymentDetailsScreen = lazy(() => import("../../screens/admin/payment/PaymentDetailsScreen.jsx"));
const PaymentGatewayScreen = lazy(() => import("../../screens/admin/payment/PaymentGatewayScreen.jsx"));
const InPersonPaymentGatewayScreen = lazy(() => import("../../screens/admin/payment/InPersonPaymentGatewayScreen.jsx"));
const RestoreMemberCreditsScreen = lazy(() => import("../../screens/admin/payment/RestoreMemberCreditsScreen.jsx"));
const CouponCodesScreen = lazy(() => import("../../screens/admin/payment/CouponCodesScreen.jsx"));
const CouponUsedScreen = lazy(() => import("../../screens/admin/payment/CouponUsedScreen.jsx"));
const ManageGamesScreen = lazy(() => import("../../screens/admin/games/ManageGamesScreen.jsx"));

const MyMembershipsScreen = lazy(() => import("../../screens/admin/MyMembershipsScreen.jsx"));
const MessageCenterScreen = lazy(() => import("../../screens/admin/messagecenter/MessageCenterScreen"));
const MessageHistoryScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryScreen"));
const MessageHistoryDetailScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryDetailScreen"));
const UpcomingScreen = lazy(() => import("../../screens/admin/UpcomingScreen"));

/** Shared placeholder route for nav items whose screens are not implemented yet. */
const upcoming = (path, uid) => ({
    path,
    uid,
    layout: "/admin",
    element: UpcomingScreen,
    exact: true,
});

export const adminRoutes = [
    {
        path: "/dashboard",
        uid: UIDs.screens.admin.dashboard,
        layout: "/admin",
        element: DashboardScreen,
    },
    {
        path: "/products/list",
        uid: UIDs.screens.admin.products.list,
        layout: "/admin",
        element: ProductListScreen,
    },
    {
        path: "/products/create",
        uid: UIDs.screens.admin.products.create,
        layout: "/admin",
        element: ProductCreateScreen,
    },
    {
        path: "/products/:id",
        uid: UIDs.screens.admin.products.details,
        layout: "/admin",
        element: ProductDetailsScreen,
    },
    {
        path: "/order/create",
        uid: UIDs.screens.admin.order.create,
        layout: "/admin",
        element: OrderCreateScreen,
    },
    {
        path: "/order/list",
        uid: UIDs.screens.admin.order.list,
        layout: "/admin",
        element: OrderListScreen,
    },
    {
        path: "/order/:id",
        uid: UIDs.screens.admin.order.details,
        layout: "/admin",
        element: OrderDetailsScreen,
    },
    {
        path: "/ecommerce",
        uid: UIDs.screens.admin.ecommerce,
        layout: "/admin",
        element: EcommerceScreen,
    },
    {
        path: "/invoices/create",
        uid: UIDs.screens.admin.invoices.create,
        layout: "/admin",
        element: InvoiceCreateScreen,
    },
    {
        path: "/invoices/list",
        uid: UIDs.screens.admin.invoices.list,
        layout: "/admin",
        element: InvoiceListScreen,
    },
    {
        path: "/invoices/:id",
        uid: UIDs.screens.admin.invoices.details,
        layout: "/admin",
        element: InvoiceDetailsScreen,
    },
    {
        path: "/invoices/invoice/:id",
        uid: UIDs.screens.admin.invoices.invoice,
        layout: "/admin",
        element: InvoiceScreen,
    },
    {
        path: "/checkout",
        uid: UIDs.screens.admin.checkout,
        layout: "/admin",
        element: CheckoutScreen,
    },
    {
        path: "/facility/facilityaccess",
        uid: UIDs.screens.admin.facility.facilityaccess,
        layout: "/admin",
        element: FacilityAccessScreen ,
    },
    {
        path: "/facility/facilityrainoutlist",
        uid: UIDs.screens.admin.facility.facilityrainoutlist,
        layout: "/admin",
        element: FacilityRainOutListScreen,
    },
    {
        path: "/facility/viewfacility",
        uid: UIDs.screens.admin.facility.viewfacility,
        layout: "/admin",
        element: ViewFacilityScreen,
    },
    {
        path: "/facility/facilityliveview",
        uid: UIDs.screens.admin.facility.facilityliveview,
        layout: "/admin",
        element: FacilityLiveViewScreen,
    },
    {
        path: "/facility/editfacilityaccess",
        uid: UIDs.screens.admin.facility.editfacilityaccess,
        layout: "/admin",
        element: EditFacilityAccessScreen,
    },
    {
        path: "/facility/editfacility",
        uid: UIDs.screens.admin.facility.editfacility,
        layout: "/admin",
        element: EditFacilityScreen,
    },
    {
        path: "/facility/editfacilityarea",
        uid: UIDs.screens.admin.facility.editfacilityarea,
        layout: "/admin",
        element: EditFacilityAreaScreen,
    },
    {
        path: "/facility/facilityaccesshistory",
        uid: UIDs.screens.admin.facility.facilityaccesshistory,
        layout: "/admin",
        element: FacilityAccessHistoryScreen,
    },
    {
        path: "/facility/facilitycheckin",
        uid: UIDs.screens.admin.facility.facilitycheckin,
        layout: "/admin",
        element: FacilityCheckInScreen,
    },
    {
        path: "/network/membermanagement",
        uid: UIDs.screens.admin.network.membermanagement,
        layout: "/admin",
        element: MemberManagementScreen,
    },
    {
        path: "/network/activatemembers",
        uid: UIDs.screens.admin.network.activatemembers,
        layout: "/admin",
        element: ActivateMembersScreen,
    },
    {
        path: "/network/memberactivityhistory",
        uid: UIDs.screens.admin.network.memberactivityhistory,
        layout: "/admin",
        element: MemberActivityHistoryScreen,
    },
    {
        path: "/network/signedwaivers",
        uid: UIDs.screens.admin.network.signedwaivers,
        layout: "/admin",
        element: SignedWaiversScreen,
    },
    {
        path: "/network/exportstatisticalreport",
        uid: UIDs.screens.admin.network.exportstatisticalreport,
        layout: "/admin",
        element: ExportStatisticalReportScreen,
    },
    {
        path: "/network/intramuralsstatistics",
        uid: UIDs.screens.admin.network.intramuralsstatistics,
        layout: "/admin",
        element: IntramuralsStatisticsScreen,
    },
    {
        path: "/network/clubstatistics",
        uid: UIDs.screens.admin.network.clubstatistics,
        layout: "/admin",
        element: ClubStatisticsScreen,
    },
    {
        path: "/network/fitnessstatistics",
        uid: UIDs.screens.admin.network.fitnessstatistics,
        layout: "/admin",
        element: FitnessStatisticsScreen,
    },
    {
        path: "/network/reservationstatistics",
        uid: UIDs.screens.admin.network.reservationstatistics,
        layout: "/admin",
        element: ReservationStatisticsScreen,
    },
    {
        path: "/network/marchmadness",
        uid: UIDs.screens.admin.network.marchmadness,
        layout: "/admin",
        element: MarchMadnessScreen,
    },
    {
        path: "/network/suspensiondetail",
        uid: UIDs.screens.admin.network.suspensiondetail,
        layout: "/admin",
        element: SuspensionDetailScreen,
    },
    {
        path: "/network/editsuspension",
        uid: UIDs.screens.admin.network.editsuspension,
        layout: "/admin",
        element: EditSuspensionScreen,
    },
    {
        path: "/network/suspensions",
        uid: UIDs.screens.admin.network.suspensions,
        layout: "/admin",
        element: SuspensionScreen,
    },
    {
        path: "/network/ineligibility",
        uid: UIDs.screens.admin.network.ineligibility,
        layout: "/admin",
        element: IneligibilityScreen,
    },
    {
        path: "/network/teammanagement",
        uid: UIDs.screens.admin.network.teammanagement,
        layout: "/admin",
        element: TeamManagementScreen,
    },
    {
        path: "/network/sidimport",
        uid: UIDs.screens.admin.network.sidimport,
        layout: "/admin",
        element: SidImportScreen,
    },
    {
        path: "/network/sidmanagement",
        uid: UIDs.screens.admin.network.sidmanagement,
        layout: "/admin",
        element: SidManagementScreen,
    },
    {
        path: "/network/createaccounts",
        uid: UIDs.screens.admin.network.createaccounts,
        layout: "/admin",
        element: CreateAccountsScreen,
    },
    {
        path: "/network/accountimport",
        uid: UIDs.screens.admin.network.accountimport,
        layout: "/admin",
        element: AccountImportScreen,
    },
    {
        path: "/network/addofficial",
        uid: UIDs.screens.admin.network.official,
        layout: "/admin",
        element: OfficialScreen,
    },
    {
        path: "/network/official",
        uid: UIDs.screens.admin.network.official,
        layout: "/admin",
        element: OfficialScreen,
    },
    {
        path: "/network/officialsearch",
        uid: UIDs.screens.admin.network.officialsearch,
        layout: "/admin",
        element: OfficialSearchScreen,
    },
    {
        path: "/network/referee",
        uid: UIDs.screens.admin.network.referee,
        layout: "/admin",
        element: RefereeScreen,
    },
    {
        path: "/club/formmanage",
        uid: UIDs.screens.admin.club.formmanage,
        layout: "/admin",
        element: FormManageScreen,
    },
    {
        path: "/club/viewformresponses",
        uid: UIDs.screens.admin.club.viewformresponses,
        layout: "/admin",
        element: ViewFormResponsesScreen,
    },
    {
        path: "/club/travelrequestmanage",
        uid: UIDs.screens.admin.club.travelrequestmanage,
        layout: "/admin",
        element: TravelRequestManageScreen,
    },
    {
        path: "/club/travelrequests",
        uid: UIDs.screens.admin.club.travelrequests,
        layout: "/admin",
        element: TravelRequestsScreen,
    },
    {
        path: "/network/moveteams",
        uid: UIDs.screens.admin.network.moveteams,
        layout: "/admin",
        element: MoveTeamsScreen,
    },
    {
        path: "/network/movegames",
        uid: UIDs.screens.admin.network.movegames,
        layout: "/admin",
        element: MoveGamesScreen,
    },
    {
        path: "/network/movemembers",
        uid: UIDs.screens.admin.network.movemembers,
        layout: "/admin",
        element: MoveMembersScreen,
    },
    {
        path: "/network/swipecardcheckin",
        uid: UIDs.screens.admin.network.swipecardcheckin,
        layout: "/admin",
        element: SwipeCardCheckInScreen,
    },
    // {
    //     path: "/sport/:sportId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/sport/:sportId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/sport/:sportId/movemembers",
    //     uid: UIDs.screens.admin.network.movemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    // {
    //     path: "/league/:leagueId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/league/:leagueId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/league/:leagueId/movemembers",
    //     uid: UIDs.screens.admin.network.movemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    // {
    //     path: "/division/:divisionId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/division/:divisionId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/division/:divisionId/movemembers",
    //     uid: UIDs.screens.admin.network.movemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    // {
    //     path: "/team/:teamId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/team/:teamId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/team/:teamId/teammovemembers",
    //     uid: UIDs.screens.admin.network.teammovemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    {
        path: "/equipment/items",
        uid: UIDs.screens.admin.equipment.items,
        layout: "/admin",
        element: ItemsScreen,
    },
    {
        path: "/equipment/items-v2",
        uid: UIDs.screens.admin.equipment.itemsv2,
        layout: "/admin",
        element: ItemsV2Screen,
    },
    {
        path: "/equipment/viewitem",
        uid: UIDs.screens.admin.equipment.viewitem,
        layout: "/admin",
        element: ViewItemScreen,
    },
    {
        path: "/equipment/viewitem-v2",
        uid: UIDs.screens.admin.equipment.viewitemv2,
        layout: "/admin",
        element: ViewItemV2Screen,
    },
    {
        path: "/equipment/edititem",
        uid: UIDs.screens.admin.equipment.edititem,
        layout: "/admin",
        element: EditItemScreen,
    },
    {
        path: "/equipment/edititem-v2",
        uid: UIDs.screens.admin.equipment.edititemv2,
        layout: "/admin",
        element: EditItemV2Screen,
    },
    {
        path: "/equipment/home",
        uid: UIDs.screens.admin.equipment.home,
        layout: "/admin",
        element: HomeScreen,
    },
    {
        path: "/equipment/reports",
        uid: UIDs.screens.admin.equipment.reports,
        layout: "/admin",
        element: ReportsScreen,
    },
    {
        path: "/equipment/categories",
        uid: UIDs.screens.admin.equipment.categories,
        layout: "/admin",
        element: CategoriesScreen,
    },
    {
        path: "/equipment/checkouts",
        uid: UIDs.screens.admin.equipment.checkouts,
        layout: "/admin",
        element: CheckoutsScreen,
    },
    {
        path: "/equipment/reservations",
        uid: UIDs.screens.admin.equipment.reservations,
        layout: "/admin",
        element: ReservationsScreen,
    },
    {
        path: "/equipment/managers",
        uid: UIDs.screens.admin.equipment.managers,
        layout: "/admin",
        element: ManagersScreen,
    },
    {
        path: "/equipment/editmanager",
        uid: UIDs.screens.admin.equipment.editmanager,

        layout: "/admin",
        element: EditManagerScreen,
    },
    {
        path: "/equipment/policies",
        uid: UIDs.screens.admin.equipment.equipmentpolicy,
        layout: "/admin",
        element: EquipmentPolicyScreen,
    },
    {
        path: "/equipment/editcheckout",
        uid: UIDs.screens.admin.equipment.editcheckout,
        layout: "/admin",
        element: EditCheckoutScreen
    },
    {
        path: "/equipment/editreservation",
        uid: UIDs.screens.admin.equipment.editreservation,
        layout: "/admin",
        element: EditReservationScreen,
    },
    {
        path: "/equipment/editcheckout-v2",
        uid: UIDs.screens.admin.equipment.editcheckoutv2,
        layout: "/admin",
        element: EditCheckoutV2Screen,
    },
    {
        path: "/equipment/editreservation-v2",
        uid: UIDs.screens.admin.equipment.editreservationv2,
        layout: "/admin",
        element: EditReservationV2Screen,
    },
    {
        path: "/equipment/checkout-detail-v2",
        uid: UIDs.screens.admin.equipment.viewcheckoutdetailv2,
        layout: "/admin",
        element: ViewCheckoutDetailV2Screen,
    },
    {
        path: "/equipment/reservation-detail-v2",
        uid: UIDs.screens.admin.equipment.viewreservationdetailv2,
        layout: "/admin",
        element: ViewReservationDetailV2Screen,
    },
    {
        path: "/makepayment",
        uid: UIDs.screens.admin.makepayment,
        layout: "/admin",
        element: MakePaymentScreen,
    },
    // Shop routes
    {
        path: "/shop/products/list",
        uid: UIDs.screens.admin.shop.products.list,
        layout: "/admin",
        element: ShopProductListScreen,
    },
    {
        path: "/shop/products/edit",
        uid: UIDs.screens.admin.shop.products.edit,
        layout: "/admin",
        element: ShopProductEditScreen,
    },
    {
        path: "/shop/products/detail",
        uid: UIDs.screens.admin.shop.products.detail,
        layout: "/admin",
        element: ShopProductDetailScreen,
    },
    {
        path: "/shop/cart",
        uid: UIDs.screens.admin.shop.cart.cart,
        layout: "/admin",
        element: ShopCartScreen,
    },
    // Shop orders routes
    {
        path: "/shop/orders/list",
        uid: UIDs.screens.admin.shop.orders.list,
        layout: "/admin",
        element: ShopOrderListScreen,
    },
    {
        path: "/shop/orders/detail",
        uid: UIDs.screens.admin.shop.orders.detail,
        layout: "/admin",
        element: ShopOrderDetailScreen,
    },
    {
        path: "/shop/checkout",
        uid: UIDs.screens.admin.shop.checkout.checkout,
        layout: "/admin",
        element: ShopCheckoutScreen,
    },
    // Payment management
    {
        path: "/payment/received",
        uid: UIDs.screens.admin.payment.received,
        layout: "/admin",
        element: ReceivedPaymentsScreen,
    },
    {
        path: "/payment/required",
        uid: UIDs.screens.admin.payment.required,
        layout: "/admin",
        element: RequiredPaymentsScreen,
    },
    {
        path: "/payment/restore-member-credits",
        uid: UIDs.screens.admin.payment.restoremembercredits,
        layout: "/admin",
        element: RestoreMemberCreditsScreen,
    },
    {
        path: "/payment/details",
        uid: UIDs.screens.admin.payment.details,
        layout: "/admin",
        element: PaymentDetailsScreen,
    },
    {
        path: "/payment/coupons/codes",
        uid: UIDs.screens.admin.payment.couponcodes,
        layout: "/admin",
        element: CouponCodesScreen,
    },
    {
        path: "/payment/coupons/used",
        uid: UIDs.screens.admin.payment.couponused,
        layout: "/admin",
        element: CouponUsedScreen,
    },
    {
        path: "/payment/gateway",
        uid: UIDs.screens.admin.payment.gateway,
        layout: "/admin",
        element: PaymentGatewayScreen,
    },
    {
        path: "/payment/inperson-gateway",
        uid: UIDs.screens.admin.payment.inpersongateway,
        layout: "/admin",
        element: InPersonPaymentGatewayScreen,
    },
    {
        path: "/games/managegames",
        uid: UIDs.screens.admin.games.managegames,
        layout: "/admin",
        element: ManageGamesScreen,
    },
    //Payment management end
    {
        path: "/facilitycalendar",
        uid: UIDs.screens.portal.facilitycalendar,
        layout: "/admin",
        element: FacilityCalendarScreen,
        exact: true,
    },
    {
        path: "/mymemberships",
        uid: UIDs.screens.admin.mymemberships,
        layout: "/admin",
        element: MyMembershipsScreen,
    },
    {
        path: "/membership/list",
        uid: UIDs.screens.admin.membership.membershiplist,
        layout: "/admin",
        element: MembershipsListScreen,
    },
    {
        path: "/membership/edit",
        uid: UIDs.screens.admin.membership.editmembership,
        layout: "/admin",
        element: EditMembershipScreen,
    },
    {
        path: "/membership/detail",
        uid: UIDs.screens.admin.membership.membershipdetail,
        layout: "/admin",
        element: ViewMembershipScreen,
    },
    {
        path: "/membership/usage-history",
        uid: UIDs.screens.admin.membership.membershipusagehistory,
        layout: "/admin",
        element: MembershipUsageHistoryScreen,
    },
    //Greg Added
    {
        path: "/offerings/settings",
        uid: UIDs.screens.admin.offeringssettings,
        layout: "/admin",
        element: OfferingsSettingsScreen,
        exact: true,
    },
    {
        path: "/offerings",
        uid: UIDs.screens.admin.offerings,
        layout: "/admin",
        element: OfferingsScreen,
        exact: true,
    },
    {
        path: "/eventcalendar/calendarlist",
        uid: UIDs.screens.admin.eventcalendar.calendarlist,
        layout: "/admin",
        element: CalendarListScreen,
    },
    {
        path: "/eventcalendar/editcalendar",
        uid: UIDs.screens.admin.eventcalendar.editcalendar,
        layout: "/admin",
        element: EditCalendarScreen,
    },
    {
        path: "/locker/roomlist",
        uid: UIDs.screens.admin.locker.roomlist,
        layout: "/admin",
        element: RoomListScreen,
    },
    {
        path: "/locker/editroom",
        uid: UIDs.screens.admin.locker.editroom,
        layout: "/admin",
        element: EditRoomScreen,
    },
    {
        path: "/locker/floorplandesign",
        uid: UIDs.screens.admin.locker.floorplandesign,
        layout: "/admin",
        element: FloorplanDesignScreen,
    },
    {
        path: "/locker/lockermanage",
        uid: UIDs.screens.admin.locker.lockermanage,
        layout: "/admin",
        element: LockerManagementScreen,
    },
    {
        path: "/messagehistory",
        uid: UIDs.screens.admin.messagehistory,
        layout: "/admin",
        element: MessageHistoryScreen,
    },
    {
        path: "/messagecenter",
        uid: UIDs.screens.admin.messagecenter,
        layout: "/admin",
        element: MessageCenterScreen,
    },
    {
        path: "/messagehistorydetail",
        uid: UIDs.screens.admin.messagehistorydetail,
        layout: "/admin",
        element: MessageHistoryDetailScreen,
    },

    // ─── Upcoming placeholders (nav IA; screens not yet implemented) ───────
    upcoming("/myhome", UIDs.screens.portal.home),
    upcoming("/intramurals", UIDs.screens.admin.intramurals.dashboard),
    upcoming("/intramurals/public", UIDs.screens.portal.intramuralhome),
    upcoming("/intramurals/leagues", UIDs.screens.admin.intramurals.leagues),
    upcoming("/intramurals/seasons", UIDs.screens.admin.intramurals.seasons),
    upcoming("/intramurals/add-sport-league", UIDs.screens.admin.intramurals.addSportLeague),
    upcoming("/intramurals/add-sport", UIDs.screens.admin.intramurals.addSport),
    upcoming("/intramurals/id-sheet", UIDs.screens.admin.network.sidmanagement),
    upcoming("/intramurals/schedule", UIDs.screens.admin.network.managegames),
    upcoming("/intramurals/standings", UIDs.screens.admin.intramurals.standings),
    upcoming("/intramurals/approvals", UIDs.screens.admin.intramurals.approvals),
    upcoming("/intramurals/officials", UIDs.screens.admin.network.referee),
    upcoming("/intramurals/captains", UIDs.screens.admin.intramurals.captains),
    upcoming("/intramurals/settings", UIDs.screens.admin.intramurals.settings),
    upcoming("/club-sports", UIDs.screens.admin.clubsports.dashboard),
    upcoming("/club-sports/clubs", UIDs.screens.admin.clubsports.clubs),
    upcoming("/club-sports/members", UIDs.screens.admin.clubsports.members),
    upcoming("/club-sports/financials", UIDs.screens.admin.clubsports.financials),
    upcoming("/club-sports/travel", UIDs.screens.admin.club.travelrequestmanage),
    upcoming("/club-sports/settings", UIDs.screens.admin.clubsports.settings),
    upcoming("/fitness", UIDs.screens.admin.fitness),
    upcoming("/personal-training", UIDs.screens.admin.personaltraining.dashboard),
    upcoming("/pos", UIDs.screens.admin.pos.register),
    upcoming("/roles", UIDs.screens.admin.roles.list),
    upcoming("/guests", UIDs.screens.admin.guest.guests),
    upcoming("/network-settings", UIDs.screens.admin.networksettings),
    upcoming("/network/seasons", UIDs.screens.admin.network.seasons),
    upcoming("/reports", UIDs.screens.admin.reports.participation),
    upcoming("/workforce", UIDs.screens.admin.workforce.dashboard),
    upcoming("/incidents", UIDs.screens.admin.incidents.list),
    upcoming("/forms/templates", UIDs.screens.admin.forms.templates),
    upcoming("/docs", UIDs.screens.admin.docs.index),
    upcoming("/internal/modules", UIDs.screens.admin.internal.modules),
];
